// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__yUbqt","footer":"ModalFilter_footer__1qMzD"};